import { render, staticRenderFns } from "./BeltSelectMonthly.vue?vue&type=template&id=a5ed4616&scoped=true"
import script from "./BeltSelectMonthly.vue?vue&type=script&lang=js"
export * from "./BeltSelectMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed4616",
  null
  
)

export default component.exports